import { useMemo } from "react"
import { useField } from "formik"

import type { ProductWithQuantity } from "../../../createOrderTypes"
import type { DeliveryTimesField } from "../../form/formTypes"
import { DynamicConfigKey } from "../../form/formTypes"

export function useMeetingTimeRequired(): boolean {
    const [{ value: deliveries }] = useField<DeliveryTimesField | undefined>(DynamicConfigKey.MULTIPLE_DELIVERIES)

    return useMemo(() => {
        if (!deliveries?.deliveryTimes) return false
        return deliveries.deliveryTimes.some((dt) =>
            dt.orderLines.some(
                (line) => "isMeetingTimeRequired" in line && (line as ProductWithQuantity).isMeetingTimeRequired,
            ),
        )
    }, [deliveries])
}
